import React, { useEffect, useRef } from 'react';
import { Heading, HeadingHierarchy } from '../../Heading/Heading';
import bem from '../../../../lib/bemUtils/bem';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../../components/atoms/SVG';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

type AttachedFilesPreviewListProps = {
  selection: File[];
  hierarchy: HeadingHierarchy;
  buttonDisabled?: boolean;
  focusLastElement?: boolean;
  onClick: (item: File, index: number) => void;
};

export function AttachedFilesPreviewList({
  selection,
  hierarchy,
  buttonDisabled,
  focusLastElement,
  onClick,
}: AttachedFilesPreviewListProps) {
  const { t } = useSonTranslation('FileUpload');
  const ulRef = useRef<HTMLUListElement>(null);
  const id = useHtmlValidId();

  useEffect(() => {
    if (ulRef.current && focusLastElement) {
      Array.from(ulRef.current.getElementsByTagName('button')).at(-1)?.focus();
    }
  }, [focusLastElement, selection]);

  return (
    <>
      <Heading
        hierarchy={hierarchy}
        className={bem('attached-files-base__headline', 'list') + ' font-bold-15-19'}
        id={`attached-files-list-headline-${id}`}
      >
        {t('selectedFiles')}
      </Heading>
      {/* Since selection and selectedFiles are the same, ul is not empty */}
      <ul
        className="attached-files-base__preview-list font-regular-14-19"
        aria-labelledby={`attached-files-list-headline-${id}`}
        ref={ulRef}
      >
        {selection.map((file, index) => {
          return (
            <li key={file.name} className="attached-files-base__preview-list-element">
              <div className="attached-files-base__preview-list-file-name">{file.name}</div>
              <div className="attached-files-base__preview-list-button">
                <ButtonMinorAction
                  text={t('deleteButtonText', { fileName: file.name })}
                  icon={Icons.DELETE_X_SMALL}
                  disabled={buttonDisabled}
                  onClick={() => onClick(file, index)}
                  tooltipPlacement={TooltipPlacement.TOP}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
}
